'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (variable, context) {
  if (typeof window === 'undefined') return;

  if (!context || context === document) {
    context = document.documentElement;
  }

  return window.getComputedStyle(context).getPropertyValue('--' + variable).trim();
};